export const changeEvent: React.ChangeEventHandler<HTMLInputElement> = (e) => e.target.checked;
